import { render, staticRenderFns } from "./moods.vue?vue&type=template&id=3c1012a6&scoped=true&"
import script from "./moods.vue?vue&type=script&lang=js&"
export * from "./moods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1012a6",
  null
  
)

export default component.exports